export const flattenObjectValues = <T extends object>(obj: T): T[keyof T][] =>
  Object.values(obj).flatMap((value): T[keyof T][] =>
    value && typeof value === "object" ? flattenObjectValues(value) : [value],
  );
